export default "__VITE_ASSET__CxE9gMAT__"